<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="home-news-content py-4 px-2 py-sm-5 px-sm-0 mt-0 mb-4">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-2">TWC Institutional Repository</h1>
            <p><strong>The Tung Wah College Institutional Repository (TWCIR)</strong> aims to collect, preserve, and provide access to the educational and research outputs authored by members of Tung Wah College. The Repository supports the College’s mission by enhancing the visibility and impact of the College’s intellectual output and fostering opportunities for collaboration.</p>
        
                <p>For enquiries, please feel free to contact the Library at 
                    <a href="mailto:lbresearch@twc.edu.hk">lbresearch&#64;twc.edu.hk</a> or call <a href="tel:+85231906650">3190-6650</a>.
                    Please refer to <a href="https://twc-hk.libguides.com/institutional-repository" target="_blank">Repository User Guide</a> for more useful tips and FAQ.    
                </p>

    
        </div>
      </div>

    </div>
  </div>
  <picture class="background-image">
    <!--<source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1200w, assets/dspace/images/banner-tall.webp 768w"> -->
    <source type="image/jpg" srcset="assets/dspace/images/banner/PC.png 2000w, assets/dspace/images/banner/Tablet.png 1200w, assets/dspace/images/banner/Mobile.png 768w">
    <img alt="" [src]="'assets/dspace/images/banner/PC.png'"/><!-- without the []="''" Firefox downloads both the fallback and the resolved image -->
  </picture>

</div>
